const BECOME_MEMBER_URL =
  typeof window === "undefined" ||
  window.location.origin === "https://skademelding.naf.no"
    ? "https://www.naf.no/bli-medlem"
    : "https://test.naf.no/bli-medlem";
export default BECOME_MEMBER_URL;
